module.exports = __webpack_public_path__ + "static/img/ic_logo.1fec8592.png";